import { EnumTypeValue } from "@/shared/types";

export const Reikwijdte = {
    Stations: "Stations",
    Trajecten: "Trajecten",
    Landelijk: "Landelijk",
} as const;

export type Reikwijdte = EnumTypeValue<typeof Reikwijdte>;

export const ReikwijdteValues = [Reikwijdte.Stations, Reikwijdte.Trajecten, Reikwijdte.Landelijk] as const;
export type ReikwijdteValues = EnumTypeValue<typeof Reikwijdte>;
